import ServiceBase from "@app/shared/serviceBase";
import { ProjectRunPerformanceResult, ProjectSummaryResult } from "./types";

export class ProjectPerformanceService extends ServiceBase {

  public async getProjectsByClient(clientId: number, signal?: AbortSignal): Promise<ProjectSummaryResult[]> {
    return await this.makeGet<ProjectSummaryResult[]>(
      "operations/project-performance/projects",
      { clientId },
      undefined,
      false,
      undefined,
      signal
    );
  }

  public async getProjectRunData(projectId: number, signal?: AbortSignal): Promise<ProjectRunPerformanceResult[]> {
    return await this.makeGet<ProjectRunPerformanceResult[]>(
      `operations/project-performance/${projectId}/run-data`,
      undefined,
      undefined,
      false,
      undefined,
      signal
    );
  }
}